import { Injectable } from '@angular/core';
import { MedicalInfo } from './medical-info';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class MedicalInfoService {

  public medicalInfo!: MedicalInfo;
  public medicalForm!: FormGroup;

  constructor() {}

  onChanges(): void {
    this.medicalForm.valueChanges.subscribe(val => {
      console.log(val);
    })
  }


}
